import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
import { TriggerService } from '../../../../core/trigger/trigger_service';

export function getAssistentConfigAngemieteteFahrzeuge(data: any, triggerService: TriggerService): AssistentItem {
    const modul: string = (data || {}).MODUL_SELECTED || null;
    const eingabe_fahrzeug = {
        gliederung: modul === 'cfm' ? '2.5.3' : '2.4.3',
        name: 'Angemietete Fahrzeuge',
        dataName: 'Angemietete Fahrzeuge',
        description: 'Dies ist das Formular zur Eingabe der angemieteten Fahrzeuge.',
        type: 'EntityForm',
        addLabel: 'Neues Fahrzeug erfassen',
        entity: IDs.ENT_ANGEMIETETE_FAHRZEUGE,
        style: { marginLeft: 18 },
        // configFlag: 'inputWasser',
        customOnSaveDone: (entity: string, dataItem: any) => {
            triggerService.fire('reload', IDs.ENT_ANGEMIETETE_FAHRZEUGE);
        }
    };
    return eingabe_fahrzeug;
}
